<p style="text-align: right;" *ngIf="!isHistoryView">
  <span style="color: #ffa626;font-family: Montserrat, Arial, Helvetica, sans-serif;cursor: pointer;">
    <strong (click)="loadClosed()">{{goToClosedLinkLabel}} &gt;</strong>
  </span>
</p>
<p style="text-align: right;" *ngIf="isHistoryView">
  <span style="color: #ffa626;font-family: Montserrat, Arial, Helvetica, sans-serif;cursor: pointer;">
    <strong (click)="loadCurrent()">&lt; {{backLinkLabel}}</strong>
  </span>
</p>
<div class="fusion-sep-clear"></div>
<div *ngIf="(!isHistoryView && (!currentCards || currentCards.length === 0)) || (isHistoryView && (!closedCards || closedCards.length === 0))" style="text-align: center;margin-top: 8vh;margin-bottom: 8vh;">
  <p style="font-size: 1.5rem;" ><strong>{{emptyLabel}}</strong></p>
</div>
<div class="fusion-separator fusion-full-width-sep sep-none"
  style="margin-left: auto;margin-right: auto;margin-top:30px;"></div>
<div *ngFor="let card of currentCards">
  <div 
    class="fusion-layout-column fusion_builder_column fusion_builder_column_1_1 fusion-builder-nested-column-5 fusion-one-full fusion-column-first fusion-column-last 1_1"
    style='margin-top: 0px;margin-bottom: 0px;'>
    <div class="fusion-column-wrapper fusion-column-wrapper-5"
      style="background-color:var(--ng-app-light-grey-color);padding: 0px 0px 10px 20px;background-position:left top;background-repeat:no-repeat;-webkit-background-size:cover;-moz-background-size:cover;-o-background-size:cover;background-size:cover;"
      data-bg-url="">
       <div style="display: inline-flex; justify-content: right; width:100%;">
        <div *ngIf="card.cluster" class="fusion-text" style="margin-right: 5px;">
          <p style="text-align: right;margin-bottom: 4px;line-height: 1.2;"><span
              class="ng-announcement-offer">{{'Cluster'}}</span></p>
        </div>
        <div class="fusion-text">
          <p style="text-align: right;margin-bottom: 4px;line-height: 1.2;"><span class="ng-tender-status">{{getStatusDesciption(card.tenderStatus)}}</span></p>
        </div>
      </div>
      <div class="fusion-builder-row-2" style="padding-right: 20px">
        <div class="fusion-text">
          <p class="ng-tender-title"><strong>{{card.title}}</strong></p>
        </div>
        <div *ngIf="card.customer" style="font-family: Montserrat, Arial, Helvetica, sans-serif; margin-bottom: 5px;">
            <span style="height:25px;width:25px;margin-right:11.2px;"
                class="icon-wrapper circle-no"><i class="fusion-li-icon fa-share-alt fas"
                style="color:var(--ng-app-theme-yellow-color);"></i></span>
            <strong style="padding: 3px 0px; font-size: 16px; color: var(--ng-app-theme-yellow-color);">
                Condivisa da: {{card.customer}}</strong>
        </div>
        <div class="ng-tender-description">
          <h5 style="font-size: 17px;">{{card.description}}</h5>
        </div>
      </div>
      <div class="fusion-builder-row fusion-builder-row-inner fusion-row" style="padding-right: 20px">
        <div
          class="fusion-layout-column fusion_builder_column fusion_builder_column_1_2 fusion-builder-nested-column-1 fusion-one-half fusion-column-first 1_2"
          style='margin-top: 10px; margin-bottom: 10px; width: 50%; width: calc(50% - ( ( 4% ) * 0.5 ) ); margin-right: 4%;'>
          <div class="fusion-column-wrapper fusion-column-wrapper-1" >
            <div class="fusion-text">
              <h5>Dal {{getFormattedDate(card.expectedStartDate)}} al {{getFormattedDate(card.expectedEndDate)}}</h5>
              <h5>{{card.province}}</h5>
              <h5>{{getCategoryName(card.category)}}</h5>
            </div>          
          </div>
        </div>
        <div
          class="fusion-layout-column fusion_builder_column fusion_builder_column_1_2 fusion-builder-nested-column-2 fusion-one-half fusion-column-last 1_2 ng-tender-detail-link"
          style="margin-top: 10px; margin-bottom: 10px; width: 50%; width: calc(50% - ( ( 4% ) * 0.5 ) );">
          <style type="text/css">
            @media only screen and (max-width:800px) {
                .ng-div-detail-link {
                    margin-top: 0px !important;
                }
                .ng-detail-link {
                    padding-top: 0px !important;
                }
            }
          </style>
          <div *ngIf="!isParticipations || card.accepted" class="fusion-column-wrapper fusion-column-wrapper-2 ng-div-detail-link" style="margin-top: 14px;">
            <div class="fusion-text">
              <p style="text-align: right;padding-top: 25px;margin-bottom: 0;cursor: pointer;" class="ng-detail-link" *ngIf="isDetailVisible(card.tenderStatus)">
                <a (click)="goToDetail(card)">Vai al dettaglio &gt;</a>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="isParticipations && !card.accepted" class="fusion-builder-row-2" style="padding-right: 20px">
        <div class="fusion-text">
          <p class="ng-tender-title-2"><strong>Si prega di attendere, la tua gara sarà disponibile non appena il Proponente darà il consenso. Qualora il proponente non dovesse accettare la candidatura, Skimming provvederà a rilasciare un ristoro per partecipare gratuitamente ad un'altra gara d'appalto a vostra scelta</strong></p>
        </div>
    </div>
  </div>
  <div class="fusion-sep-clear"></div>
  <div class="fusion-separator fusion-full-width-sep sep-none"
    style="margin-left: auto;margin-right: auto;margin-top:30px;"></div>
</div>
</div>
<div *ngFor="let card of closedCards">
  <div
    class="fusion-layout-column fusion_builder_column fusion_builder_column_1_1 fusion-builder-nested-column-5 fusion-one-full fusion-column-first fusion-column-last 1_1"
    style='margin-top: 0px;margin-bottom: 0px;'>
    <div class="fusion-column-wrapper fusion-column-wrapper-5"
      style="background-color:var(--ng-app-light-grey-color);padding: 0px 0px 20px 20px;background-position:left top;background-repeat:no-repeat;-webkit-background-size:cover;-moz-background-size:cover;-o-background-size:cover;background-size:cover;"
      data-bg-url="">
      <div class="fusion-text" style="margin-bottom: 15px;">
        <p style="text-align: right;margin-bottom: -10px;line-height: 1.2;"><span class="ng-tender-status">{{getStatusDesciption(card.tenderStatus)}}</span></p>
      </div>
      <div class="fusion-builder-row-2" style="padding-right: 20px">
        <div class="fusion-text">
          <p class="ng-tender-title"><strong>{{card.title}}</strong></p>
        </div>
        <div class="ng-tender-description">
          <h5 style="font-size: 17px;">{{card.description}}</h5>
        </div>
      </div>
      <div class="fusion-builder-row fusion-builder-row-inner fusion-row" style="padding-right: 20px">
        <div
          class="fusion-layout-column fusion_builder_column fusion_builder_column_1_2 fusion-builder-nested-column-1 fusion-one-half fusion-column-first 1_2"
          style='margin-top: 10px; margin-bottom: 10px; width: 50%; width: calc(50% - ( ( 4% ) * 0.5 ) ); margin-right: 4%;'>
          <div class="fusion-column-wrapper fusion-column-wrapper-1" >
            <div class="fusion-text">
              <h5>Dal {{getFormattedDate(card.expectedStartDate)}} al {{getFormattedDate(card.expectedEndDate)}}</h5>
              <h5>{{card.province}}</h5>
              <h5>{{getCategoryName(card.category)}}</h5>
            </div>          
          </div>
        </div>
        <div
          class="fusion-layout-column fusion_builder_column fusion_builder_column_1_2 fusion-builder-nested-column-2 fusion-one-half fusion-column-last 1_2 ng-tender-detail-link"
          style="margin-top: 10px; margin-bottom: 10px; width: 50%; width: calc(50% - ( ( 4% ) * 0.5 ) );">
          <div class="fusion-column-wrapper fusion-column-wrapper-2 ng-div-detail-link" style="margin-top: 14px;">
            <div class="fusion-text">
              <p style="text-align: right;padding-top: 25px;margin-bottom: 0;cursor: pointer;" class="ng-detail-link" *ngIf="isDetailVisible(card.tenderStatus)">
                <a (click)="goToDetail(card)">Vai al dettaglio &gt;</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="fusion-sep-clear"></div>
  <div class="fusion-separator fusion-full-width-sep sep-none"
    style="margin-left: auto;margin-right: auto;margin-top:30px;"></div>
</div>
<div class="fusion-text" *ngIf="showMore">
  <p style="text-align: right;padding-top: 25px;margin-bottom: 0;"><a style="font-weight: 600;cursor: pointer;" (click)="loadMore()"
    target="_self">{{showMoreLabel}} &gt;</a></p>
</div>